import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { advertisementList } from "Apis/advertisement";

export const EventContext = createContext();

export const EventContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [advertisementData, setAdvertisementData] = useState();

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  const advertisementAllList = async () => {
    const response = await advertisementList();
    const advertisement = response?.data?.data?.rows?.map((data) => ({
      label: data?.title,
      value: data?.id,
    }));
    setAdvertisementData(advertisement);
  };

  return (
    <EventContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
        advertisementData,
        advertisementAllList,
      }}
    >
      {children}
    </EventContext.Provider>
  );
};

export default EventContextProvider;
EventContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
